<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1907 21.6187C20.5803 22.0101 21.2135 22.0116 21.6049 21.622C21.9964 21.2324 21.9979 20.5992 21.6083 20.2078L20.1907 21.6187ZM18.7088 17.2946C18.3192 16.9031 17.686 16.9016 17.2946 17.2912C16.9031 17.6808 16.9016 18.314 17.2912 18.7054L18.7088 17.2946ZM16 10C16 13.3137 13.3137 16 10 16V18C14.4183 18 18 14.4183 18 10H16ZM10 16C6.68629 16 4 13.3137 4 10H2C2 14.4183 5.58172 18 10 18V16ZM4 10C4 6.68629 6.68629 4 10 4V2C5.58172 2 2 5.58172 2 10H4ZM10 4C13.3137 4 16 6.68629 16 10H18C18 5.58172 14.4183 2 10 2V4ZM21.6083 20.2078L18.7088 17.2946L17.2912 18.7054L20.1907 21.6187L21.6083 20.2078Z"
      fill="#39444C"
    />
  </svg>
</template>
